import request from "../router/request";
import router from '../router';

async function validarToken() {
    const token = localStorage.getItem('token');
    if (!token) {
        router.push('/');
        return;
    }

    try {
        await request.get('/usuario/dados', {
            headers: { Authorization: `Bearer ${token}` }
        });

    } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token'); // limpa token inválido
            router.push('/');
        } else {
            console.error('Erro inesperado na validação do token:', err);
        }
    }
}

function startTokenRefreshInterval() {
    setInterval(() => {
        if (localStorage.getItem('token')) {
            request.post("/usuario/refresh", {}, this, (response) => {
                if (response.data.token) {
                    localStorage.setItem("token", response.data.token);
                }
            });
        }
    }, 60 * 60 * 1000);
}

export default { validarToken, startTokenRefreshInterval };